<!-- Products Section -->

<span mat-button mat-dialog-close class="custom-close material-icons" 
    >close</span
  >
<div class="popup-body refund-modal" role="dialog" aria-labelledby="refund-title" aria-describedby="refund-desc">


    <div class="dialoghead assignAdvo_wrapper">
    <h1 class="mat-mdc-dialog-title orderlist-refund-custom-title">Refund Request</h1> 
    <mat-dialog-content>
        <p style="font-size: 16px;">Select the products you want to include in your refund request. You’ll be
            able to add additional comments on the next step.</p>
    </mat-dialog-content>

  </div>
    <!-- Header -->
    <!-- <div class="modal-header">
        <h2 id="refund-title" class="modal-title">Refund Request</h2>
        <p id="refund-desc" class="modal-subtitle">
            Select the products you want to include in your refund request. You’ll be
            able to add additional comments on the next step.
        </p>
        <span mat-button mat-dialog-close matTooltip="Close" matTooltipPosition="below" class="close-btn-modal material-icons"
    (click)="onNoClick()">close</span>
    </div> -->

    <!-- Order details -->
    <div class="order-summary" *ngIf="modalData as order">
        <div class="order-id">
            <strong>Order :</strong>
            <span>#{{ order.order_number || order._id || 'N/A' }}</span>
        </div>
        <div class="order-meta">
            <div class="meta-item">
                <strong>Placed on :</strong>
                <span>{{ (order.created_on ) | date:'mediumDate' }}</span>
            </div>
            <div class="meta-item">
                <strong>Total :</strong>
                <span>${{ (order.total_amount ) | number:'1.2-2' }}</span>
            </div>
            <!-- <div class="meta-item" *ngIf="order.payment_method">
                <strong>Payment</strong>
                <span>{{ order.payment_method }}</span>
            </div>
            <div class="meta-item" *ngIf="order.status">
                <strong>Status</strong>
                <span>{{ order.status }}</span>
            </div> -->
        </div>
    </div>

    <!-- List -->
    <div class="products-list" *ngIf="products?.length; else emptyState">
        <div class="product-card" *ngFor="let product of products; let i = index; trackBy: trackProduct">
            <div class="product-select">
                <mat-checkbox [checked]="selected.has(i)" (change)="onToggle(i, $event.checked)"
                    [attr.aria-label]="'Select ' + (product.product_name || 'product')"></mat-checkbox>
            </div>

            <img [src]="
          product.product_image ||
          'https://all-frontend-assets.s3.us-east-1.amazonaws.com/divine-infinity-being/custom_button_icons_image/logo_placeholder.png'
        " alt="" />

            <div class="product-details">
                <div><strong>Name:</strong> {{ product.product_name || 'N/A' }}</div>
                <div><strong>Qty:</strong> {{ product.quantity || 'N/A' }}</div>
                <div>
                    <strong>Price:</strong>
                    {{
                    product.price
                    ? ('$' + product.price)
                    : product.preorder_price
                    ? ('$' + product.preorder_price)
                    : 'N/A'
                    }}
                </div>
                <div *ngIf="product.selected_size">
                    <strong>Size:</strong> {{ product.selected_size }}
                </div>
                <div *ngIf="product.selected_color">
                    <strong>Color:</strong> {{ product.selected_color }}
                </div>
            </div>
        </div>

        <!-- Notes / Suggestions -->
        <div class="helper-notes" aria-live="polite">
            <ul>
                <li>Only select items you wish to include in this request.</li>
                <li>Refund eligibility depends on the seller’s policy and condition.</li>
                <li>Attachments or order notes can be added on the next step.</li>
            </ul>
        </div>
    </div>

    <!-- Empty state -->
    <ng-template #emptyState>
        <div class="empty-state">
            No products found for this order.
        </div>
    </ng-template>
    
  <div class="page-loader-overlay" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate" class="bottom-loader"></mat-progress-bar>
  </div>
  
    <!-- Actions -->
    <div class="actions-row">
        <button mat-button class="btn-brand btn-outline" (click)="onNoClick()">
            Cancel
        </button>
        <button mat-raised-button class="btn-brand btn-solid" (click)="submitRefundRequest()"
        [disabled]="selected.size === 0 || submitting">
            {{ submitting ? 'Submitting…' : 'Submit Refund Request' }}
        </button>
    </div>
</div>